import loadable from '@wix/yoshi-flow-editor/loadable';

export const EventsPage = loadable(
  () => import(/* webpackChunkName: "EventsPage" */ './EventsPage'),
  {
    resolveComponent: (component) => component.EventsPage,
  },
);
